import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  customerByFilter,
  fetchTotalOrder,
  createServiceTicket,
  serviceTicketDetail,
  serviceTicketList,
  orderGraph,
  createNewAddress,
  addressList,
  awardList,
  serviceRequestGraph,
  awardGraph,
  getOrderList,
  customerDetails
} from "@/services/customerManagement";
@Module({
  namespaced: true,
})
export default class CustomerManagement extends VuexModule {

  //state
  ticketData = [];
  addressData = [];
  awardData = [];
  serviceRequestData = [];
  orderGraphData = [];
  awardGraphData = [];
  orderData = [];
  customerData = {}
  //action

  @Action
  public async customerDetails(payload) {
    try {
      const data = await customerDetails(payload);
      this.context.commit("setCustomerDetails", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getOrderList(payload) {
    try {
      const data = await getOrderList(payload);
      this.context.commit("setOrderList", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }



  @Action
  public async awardGraph(payload) {
    try {
      const data = await awardGraph(payload);
      this.context.commit("setAwardGraph", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async serviceRequestGraph(payload) {
    try {
      const data = await serviceRequestGraph(payload);
      this.context.commit("setServiceRequestGraph", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async awardList(payload) {
    try {
      const data = await awardList(payload);
      this.context.commit("setAwardList", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createNewAddress(payload) {
    try {
      const data = await createNewAddress(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async addressList() {
    try {
      const data = await addressList();
      this.context.commit("setAddressList", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async orderGraph(payload) {
    try {
      const data = await orderGraph(payload);
      this.context.commit("setOrderGraph", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async serviceTicketDetail(payload) {
    try {
      let searchQuery = payload ? payload : "";
      const data = await serviceTicketDetail(payload.id, payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async serviceTicketList(payload) {
    try {
      const data = await serviceTicketList(payload);
      this.context.commit("setServiceTicketList", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createServiceTicket(payload) {
    try {
      const data = await createServiceTicket(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTotalOrder(payload) {
    try {
      const data = await fetchTotalOrder(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async customerByFilter(payload) {
    try {
      const data = await customerByFilter(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  //mutation

  @Mutation
  public setCustomerDetails(data: any) {
    this.customerData = data;
  }

  @Mutation
  public setOrderList(data: any) {
    this.orderData = data;
  }

  @Mutation
  public setAwardList(data: any) {
    this.awardData = data;
  }

  @Mutation
  public setServiceRequestGraph(data: any) {
    this.serviceRequestData = data;
  }

  @Mutation
  public setOrderGraph(data: any) {
    this.orderGraphData = data;
  }

  @Mutation
  public setAwardGraph(data: any) {
    this.awardGraphData = data;
  }

  @Mutation
  public setAddressList(data: any) {
    this.addressData = data;
  }

  @Mutation
  public setServiceTicketList(data: any) {
    this.ticketData = data;
  }

  //getters
  get GetCustomerDetails() {
    return this.customerData;
  }

  get GetOrderGraph() {
    return this.orderGraphData;
  }

  get GetServiceTicketList() {
    return this.ticketData;
  }

  get GetAddressList() {
    return this.addressData;
  }

  get GetAwardList() {
    return this.awardData;
  }

  get GetServiceRequestGraph() {
    return this.serviceRequestData;
  }

  get GetAwardGraph() {
    return this.awardGraphData;
  }

  get GetOrderList() {
    return this.orderData;
  }
}
